var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.209,
    height: 17.2,
    viewBox: "0 0 16.209 17.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting",
    transform: "translate(-0.073 -0.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M15.369,5.228l-.518-.9a1.592,1.592,0,0,0-2.171-.587h0a1.585,1.585,0,0,1-2.171-.564,1.525,1.525,0,0,1-.213-.762h0A1.592,1.592,0,0,0,8.7.778H7.658A1.585,1.585,0,0,0,6.073,2.37h0A1.592,1.592,0,0,1,4.481,3.94a1.524,1.524,0,0,1-.762-.213h0a1.592,1.592,0,0,0-2.171.587l-.556.914A1.592,1.592,0,0,0,1.571,7.4h0a1.592,1.592,0,0,1,0,2.758h0a1.585,1.585,0,0,0-.579,2.164h0l.526.907a1.592,1.592,0,0,0,2.171.617h0a1.577,1.577,0,0,1,2.164.579,1.524,1.524,0,0,1,.213.762h0a1.592,1.592,0,0,0,1.592,1.592H8.7a1.592,1.592,0,0,0,1.592-1.585h0A1.585,1.585,0,0,1,11.887,13.6a1.622,1.622,0,0,1,.762.213h0a1.592,1.592,0,0,0,2.171-.579h0l.549-.914a1.585,1.585,0,0,0-.579-2.171h0a1.585,1.585,0,0,1-.579-2.171A1.562,1.562,0,0,1,14.79,7.4h0a1.592,1.592,0,0,0,.579-2.164h0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#8d8d8d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.636,
    cy: 2.636,
    r: 2.636,
    transform: "translate(5.548 6.142)",
    fill: "none",
    stroke: "#8d8d8d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.b10769f77e90fc07a9f1fd4d7951eb00.svg";
export { ForwardRef as ReactComponent };